import * as Yup from 'yup';

const LookupSchema = Yup.object({
  email: Yup.string().email('Invalid email address').required('Required'),
});
export default LookupSchema;
